import { AppType } from '@wix/adi-core-types';
export var Volume;
(function (Volume) {
    Volume["BuiltIn"] = "built-in";
    Volume["Recommended"] = "recommended";
    Volume["Optional"] = "optional";
})(Volume || (Volume = {}));
export var MediaItemTypes;
(function (MediaItemTypes) {
    MediaItemTypes["Image"] = "image";
    MediaItemTypes["Video"] = "video";
    MediaItemTypes["Clipart"] = "clipart";
    MediaItemTypes["Shape"] = "shape";
    MediaItemTypes["Icon"] = "icon";
    MediaItemTypes["Audio"] = "audio";
    MediaItemTypes["ExtVideo"] = "extVideo";
    MediaItemTypes["Document"] = "document";
    MediaItemTypes["Pattern"] = "pattern";
})(MediaItemTypes || (MediaItemTypes = {}));
export var AppLevel = {
    BuiltIn: 'built-in',
    Preferred: 'preferred',
    Recommended: 'recommended',
    Regular: 'regular',
};
export var AppWidgetType = {
    BandsInTown_Widget: 'BandsInTown_Widget',
    Blog_Single_Post_Widget: 'Blog_Single_Post_Widget',
    Blog_Post_Gallery: 'Blog_Post_Gallery',
    Blog2_Custom_Feed_Widget: 'Blog2_Custom_Feed_Widget',
    Blog2_Post: 'Blog2_Post',
    Bookings_Widget: 'Bookings_Widget',
    Bookings_List: 'Bookings_List',
    Bookings: 'Bookings',
    Bookings_Book_Checkout: 'Bookings_Book_Checkout',
    Chat_Widget: 'Chat_Widget',
    Events: 'Events',
    Events_Single: 'Events_Single',
    Events_Multiple: 'Events_Multiple',
    Events_Schedule: 'Events_Schedule',
    GetSubscribers_Widget: 'GetSubscribers_Widget',
    Hotels_Search_Bar_Widget: 'Hotels_Search_Bar_Widget',
    Instagram_Widget: 'Instagram_Widget',
    DeviantArt_Widget: 'DeviantArt_Widget',
    Music_Widget: 'Music_Widget',
    ProGallery_Widget: 'ProGallery_Widget',
    Stores_Product_Widget: 'Stores_Product_Widget',
    Stores_Grid_Gallery_Widget: 'Stores_Grid_Gallery_Widget',
    Stores_Slider_Gallery_Widget: 'Stores_Slider_Gallery_Widget',
    Stores_Thank_You_Widget: 'Stores_Thank_You_Widget',
    Stores_Shopping_Cart_Widget: 'Stores_Shopping_Cart_Widget',
    Stores_Product_specific_Widget: 'Stores_Product_specific_Widget',
    Video_Widget: 'Video_Widget',
    Html_Embed: 'Html_Embed',
    RestaurantsMenus_Widget: 'RestaurantsMenus_Widget',
    RestaurantsOrders_Widget: 'RestaurantsOrders_Widget',
    RestaurantsReservations_Widget: 'RestaurantsReservations_Widget',
    Groups_SingleGroup: 'Groups_SingleGroup',
    Challenges_SingleChallenge: 'Challenges_SingleChallenge',
};
export function isAppWidgetType(type) {
    return Boolean(AppWidgetType[type]);
}
export function isAppType(type) {
    return Boolean(AppType[type]);
}
//# sourceMappingURL=content.js.map